module.exports = __webpack_public_path__ + "media/images/facebook_black-5332a20f.svg";